<template lang="html">
  <div>Page Not Found</div>
</template>

<script>
export default {
};
</script>
<!--
<style lang="scss" scoped>
</style> -->
